module.exports = __webpack_public_path__ + "img/hr-heat-pipe-corner-down-right-2.74bf98b3.png";